import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";
import Dynamic_FilterForm from "../../../components/Dynamic_FilterForm";
import SearchBar from "../../../components/SearchBar";
import { Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import ExportToExcel from "../../../components/ExportToExcel";
import { GetServiceCaller } from "../../../services/serviceCaller";
import { API_URL } from "../../../constants";
import { Table } from "react-bootstrap";
import { FaSpinner } from "react-icons/fa";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import Pagination from "../../../components/Pagination";
import { useMemo } from "react";

const customIndicator = {
  display: "inline-block",
  width: "20px",
  height: "20px",
  borderRadius: "50%",
  marginBottom: "0px",
  verticalAlign: "middle",
  marginLeft: "10px",
  marginRight: "3px",
  boxShadow: "0 2px 9px 0 rgba(0, 0, 0, 0.18), 0 2px 7px 0 rgba(0, 0, 0, 0.15)",
  border: "solid 2px #fff",
};

const InvoiceReportConsultingContent = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(updateNavbarHeading("Invoice Report (Consulting and content)"));
  }, [dispatch]);

  const [searchTerm, setSearchTerm] = useState("");
  const [filterFormData, setFilterData] = useState([]);
  const [invoiceReportData, setInvoiceReportData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(70);
  const [statusOptions, setStatusOption] = useState([]);
  const [overallTotal, setOverallTotal] = useState(0);
  const [loading, setLoading] = useState(true);
 const [columnVisibility, setColumnVisibility] = useState({
    ClientName: true,
    ProjectName: true,
    InvoiceDate: true,
    InvoiceNo: true,
    EmployeeName: true,
    StartDate: true,
    EndDate: true,
    BasicAmount: false,
    AdjustmentAmount: false,
    WorkingDays: false,
    PresentDays: false,
    InvoicedDays: false,
    FollowUpDate: false,
    Remarks: false,
    InvoicedAmount: true,
    TaxPercent: true,
    ExchangeRate: true,
    InvoiceCalculatedAmount: true,
    PaymentTermDays: true,
    PaymentDueDate: true,
    PaymentReceivedDate: true,
    OverDueDays: true,
    OverDueAmount: true,
    Status: true,
  });

  const [colSpan1, setColSpan1] = useState(8);
  const [colSpan2, setColSpan2] = useState(9);

  const columns = [
    { id: "InvoiceDate", label: "Invoice Date", accessor: "InvoiceDate" },
    { id: "InvoiceNo", label: "Invoice No", accessor: "InvoiceNo" },
    { id: "EmployeeName", label: "Employee", accessor: "EmployeeName" },
    { id: "PresentDays", label: "Present Days", accessor: "PresentDays" },
    { id: "WorkingDays", label: "Working Days", accessor: "WorkingDays" },
    { id: "StartDate", label: "From Date", accessor: "StartDate" },
    { id: "EndDate", label: "To Date", accessor: "EndDate" },
    { id: "BasicAmount", label: "Basic Amt.", accessor: "BasicAmount" },
    { id: "AdjustmentAmount", label: "Adj. Amt.", accessor: "AdjustmentAmount" },
    { id: "InvoicedAmount", label: "Proforma Amount", accessor: "InvoicedAmount" },
    { id: "TaxPercent", label: "Tax%", accessor: "TaxPercent" },
    { id: "ExchangeRate", label: "Exchange Rate", accessor: "ExchangeRate" },
    { id: "InvoiceCalculatedAmount", label: "Inv. Amount", accessor: "InvoiceCalculatedAmount" },
    { id: "InvoicedDays", label: "Invoiced Days", accessor: "InvoicedDays" },
    { id: "PaymentTermDays", label: "Pytm Term Days", accessor: "PaymentTermDays" },
    { id: "FollowUpDate", label: "FollowUp Date", accessor: "FollowUpDate" },
    { id: "PaymentDueDate", label: "Pytm Due Dt", accessor: "PaymentDueDate" },
    { id: "PaymentReceivedDate", label: "Pytm Recv Dt", accessor: "PaymentReceivedDate" },
    { id: "OverDueDays", label: "OverDueDays", accessor: "OverDueDays" },
    { id: "OverDueAmount", label: "OverDueAmount", accessor: "OverDueAmount" },
    { id: "Status", label: "Status", accessor: "Status" },
    { id: "Remarks", label: "Remarks", accessor: "Remarks" },
  ];

  // Find index of InvoicedAmount to separate columns before and after
  const invoicedAmountIndex = columns.findIndex(col => col.id === "InvoicedAmount");

  const toggleColumnVisibility = (columnId) => {
    setColumnVisibility((prev) => {
      const newValue = !prev[columnId];
      const columnIndex = columns.findIndex(col => col.id === columnId);

      // Decide which colspan to affect
      if (columnIndex < invoicedAmountIndex) {
        // Column is before InvoicedAmount → affect colSpan1
        setColSpan1((prevSpan) => prevSpan + (newValue ? 1 : -1));
      } else if (columnIndex > invoicedAmountIndex) {
        // Column is after InvoicedAmount → affect colSpan2
        setColSpan2((prevSpan) => prevSpan + (newValue ? 1 : -1));
      }
      // If columnIndex === invoicedAmountIndex, do nothing or handle separately if needed

      return {
        ...prev,
        [columnId]: newValue,
      };
    });
  };
// Dynamic table header component
const TableHeader = () => {
  return (
    <thead className="invoice-table-header">
      <tr>
        <th colSpan={3} style={{ backgroundColor: "#525c69", color: "#fff" }}>
          ##
        </th>
        {columns.map((column) => 
          columnVisibility[column.id] && (
            <th
              key={column.id}
              style={{
                width: "100px",
                backgroundColor: "#525c69",
                color: "#fff",
              }}
            >
              {column.label}
            </th>
          )
        )}
      </tr>
    </thead>
  );
};




  const formDatas = [
    {
      name: "From Date",
      type: "Date",
    },
    {
      name: "To Date",
      type: "Date",
    },
    {
      name: "Status",
      type: "Select",
      options: [...statusOptions],
    },
    {
      name: "Overdue",
      type: "Checkbox",
      //   options: [...employeeOption],
    },
  ];
  const handleChange = (e, name) => {
    setFilterData((prevFormData) => {
      // Check if the label already exists
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      // If the label exists, update its value
      if (existingLabelIndex !== -1) {
        const updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e.value !== undefined ? e.value : e }
            : item
        );
        return updatedFormData;
      } else {
        // If the label doesn't exist, add a new label-value pair
        return [
          ...prevFormData,
          {
            label: name,
            value: e.value !== undefined ? e.value : e, // Assuming e is an event object
          },
        ];
      }
    });
  };
  const handleGetData = async () => {
    try {
      setLoading(true);
      const fromDate =
        filterFormData.find((o) => o.label === "From Date")?.value || 0;
      const toDate =
        filterFormData.find((o) => o.label === "To Date")?.value || 0;
      const status =
        filterFormData.find((o) => o.label === "Status")?.value || "";
      const overDue =
        filterFormData.find((o) => o.label === "OverDue")?.value || false;
      const response = await GetServiceCaller(
        `${API_URL}projectmanagement/reports/1?P_FromDate=${moment(
          fromDate
        ).format("YYYY-MM-DD")}&P_ToDate=${moment(toDate).format(
          "YYYY-MM-DD"
        )}&P_OverDueDays=${overDue ? 1 : 0}&P_Status=${status}`
      );

      if (response?.status === 200) {
        const cleanedGetData = response?.data?.data;
        setInvoiceReportData(cleanedGetData);
        const total = response?.data?.data?.reduce((sum, item) => {
          return sum + (Number(item.InvoiceCalculatedAmount) || 0);
        }, 0);
        setOverallTotal(total);
      }
    } catch (error) {
      console.error("Error fetching payslip report data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchIndexApi();
  }, []);
  const fetchIndexApi = async () => {
    try {
      setLoading(true);
      let response;

      response = await GetServiceCaller(
        `${API_URL}projectmanagement/reports/1?P_FromDate=&P_ToDate=&P_OverDueDays&P_Status=`
      );

      if (response?.status === 200) {
        setInvoiceReportData(response?.data?.data);
        const total = response?.data?.data?.reduce((sum, item) => {
          return sum + (Number(item.InvoiceCalculatedAmount) || 0);
        }, 0);
        setOverallTotal(total);
        const statOpt = response?.data?.status?.map((ele, index) => ({
          value: ele?.value,
          label: ele?.text,
        }));

        setStatusOption(statOpt);
      }
    } catch (error) {
      console.error("Fetching API Error ", error);
    } finally {
      setLoading(false);
    }
  };

  // pagination
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  // Compute the current page's data
  const startIndex = (currentPage - 1) * itemsPerPage;
  // Math.min(startIndex + itemsPerPage, filteredData.length)
  const endIndex = Math.min(
    startIndex + itemsPerPage,
    invoiceReportData.length
  );
  const paginatedData = invoiceReportData.slice(startIndex, endIndex);

  const filteredData = invoiceReportData.filter((item) =>
    Object.values(item).some((value) =>
      String(value).toLowerCase().includes(searchTerm.toLowerCase())
    )
  );


    // Calculate the number of visible columns
  const visibleColumnsCount = useMemo(() => {
    return Object.values(columnVisibility).filter(visible => visible).length;
  }, [columnVisibility]);

  const [activeClientKey, setActiveClientKey] = useState([]);
  const [activeProjectKey, setActiveProjectKey] = useState({});
  const [isInitialized, setIsInitialized] = useState(false); // NEW

  useEffect(() => {
    if (!loading && filteredData.length > 0 && !isInitialized) {
      const structuredData = filteredData.reduce((acc, item) => {
        if (!acc[item.ClientName]) acc[item.ClientName] = {};
        if (!acc[item.ClientName][item.ProjectName])
          acc[item.ClientName][item.ProjectName] = [];
        acc[item.ClientName][item.ProjectName].push(item);
        return acc;
      }, {});

      // Open all clients
      const clientKeys = Object.keys(structuredData).map((_, index) => index);
      setActiveClientKey(clientKeys);

      // Open ALL projects under each client
      const projectKeyState = {};
      Object.values(structuredData).forEach((projects, clientIndex) => {
        const projectIndexes = Object.keys(projects).map((_, idx) => idx);
        projectKeyState[clientIndex] = projectIndexes;
      });
      setActiveProjectKey(projectKeyState);

      setIsInitialized(true);
    }
  }, [filteredData, loading, isInitialized]);

  const handleClientToggle = (clientIndex) => {
    setActiveClientKey((prev) =>
      prev.includes(clientIndex)
        ? prev.filter((idx) => idx !== clientIndex)
        : [...prev, clientIndex]
    );
  };
  const handleProjectToggle = (clientIndex, projectIndex) => {
    setActiveProjectKey((prev) => {
      const existing = prev[clientIndex] || [];
      const isOpen = existing.includes(projectIndex);

      return {
        ...prev,
        [clientIndex]: isOpen
          ? existing.filter((idx) => idx !== projectIndex)
          : [...existing, projectIndex],
      };
    });
  };

  const handleFilterReset = () => {
    // Reset to empty/default values without passing any specific data
    setFilterData([
      {
        employee: 0,
        fromDate: "",
        toDate: "",
        status: "",
      },
    ]);
    // Call API with empty/default parameters
    fetchIndexApi();
  };

  const InvoiceExportData = (data, columnVisibility, columns) => {
    // Create nested structure
    const nestedData = data.reduce((acc, item) => {
      if (!acc[item.ClientName]) acc[item.ClientName] = {};
      if (!acc[item.ClientName][item.ProjectName]) {
        acc[item.ClientName][item.ProjectName] = [];
      }
      acc[item.ClientName][item.ProjectName].push(item);
      return acc;
    }, {});

    // Get visible columns
    const visibleColumns = columns.filter((col) => columnVisibility[col.id]);

    // Prepare the export data
    const exportData = [];

    // Add data rows with hierarchy
    Object.entries(nestedData).forEach(([clientName, projects]) => {
      // Add client row
      const clientRow = {};
      visibleColumns.forEach((col, index) => {
        clientRow[col.label] = index === 0 ? `Client: ${clientName}` : "";
      });
      exportData.push(clientRow);

      Object.entries(projects).forEach(([projectName, items]) => {
        // Add project row
        const projectRow = {};
        visibleColumns.forEach((col, index) => {
          projectRow[col.label] =
            index === 0
              ? `Project: ${projectName} (SOW/PO/SO ${items[0]?.ProjectInvoiceDetailNumber || "N/A"
              })`
              : "";
        });
        exportData.push(projectRow);

        // Add item rows
        items.forEach((item) => {
          const row = {};
          visibleColumns.forEach((col) => {
            if (
              [
                "InvoiceDate",
                "PaymentDueDate",
                "FollowUpDate",
                "PaymentReceivedDate",
              ].includes(col.id)
            ) {
              row[col.label] = moment(item[col.accessor]).format("DD-MMM-YYYY");
            } else {
              row[col.label] = item[col.accessor] || "";
            }
          });
          exportData.push(row);
        });
      });
    });

    return exportData;
  };
  const recordsPerPageOption = [
    { value: 10, label: "10" },
    { value: 25, label: "25" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
    { value: invoiceReportData.length, label: "All" },
  ];

  const handleRecordsPerPage = (e) => {
    const newRecordsPerPage = Number(e.target.value);
    setItemsPerPage(newRecordsPerPage);
    setCurrentPage(1); // Reset to first page when changing items per page
  };
  return (
    <div className="container-fluid" id="skill_section"  style={{ position: "fixed"}}>
      <div className="container-fluid" id="skill-table-area"  style={{ height: "600px"}}>
        <div className="d-flex justify-content-between">
          <div className="d-flex">
            <div className="me-1">
              <SearchBar
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
              />
            </div>

            <div className="dropdown">
              <OverlayTrigger
                placement="right"
                overlay={<Tooltip id="tooltip-bottom">Filter</Tooltip>}
              >
                <button
                  className="dropdown-toggle"
                  type="button"
                  id="excel-btn"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="bi bi-funnel-fill"></i>
                </button>
              </OverlayTrigger>

              <div>
                <Dynamic_FilterForm
                  formData={formDatas || []}
                  handleChange={handleChange}
                  handleGetData={handleGetData}
                  filterFormData={filterFormData}
                  handleReset={handleFilterReset}
                />
              </div>
            </div>
            <div
              style={{
                backgroundColor: "#f8f9fa",
                padding: "4px 8px",
                borderRadius: "4px",
                height: "32px",
                border: "1px solid #dee2e6",
                marginLeft: "4px",
              }}
            >
              <span style={{ fontWeight: "600" }}>Total Revenue: </span>
              <span>₹ {overallTotal.toLocaleString("en-IN", { maximumFractionDigits: 0 })}</span>
            </div>
          </div>
          <div className="d-flex justify-content-end">
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="tooltip-top">Export to Excel</Tooltip>}
            >
              <div className="me-1">
                <ExportToExcel
                  // data={invoiceReportData}
                  data={InvoiceExportData(
                    invoiceReportData,
                    columnVisibility,
                    columns
                  )}
                  filename={`Invoice Report(Consulting and Content).csv`}
                />
              </div>
            </OverlayTrigger>
         <OverlayTrigger
  placement="top"
  overlay={<Tooltip id="tooltip-top">Column Chooser</Tooltip>}
>
  <div className="btn-group me-2">
    <button
      type="button"
      className="dropdown-toggle skill-button"
      data-bs-toggle="dropdown"
      aria-expanded="false"
      id="excel-btn"
    >
      <i className="bi bi-list"></i>
    </button>
    <ul className="dropdown-menu p-2" style={{ maxHeight: "400px", overflowY: "auto" }}>
      <div className="row">
        <Form.Group>
          {columns.map((column) => (
            <Form.Check
              key={column.id}
              type="checkbox"
              id={`checkbox-${column.id}`}
              label={column.label}
              checked={columnVisibility[column.id]}
              onChange={() => toggleColumnVisibility(column.id)}
            />
          ))}
        </Form.Group>
      </div>
    </ul>
  </div>
</OverlayTrigger>

          </div>
        </div>

        <div className="mb-1 d-flex align-items-center">
          <p style={{ ...customIndicator, background: "#bad893" }}></p>
          <span className="me-3">FixedBid</span>
          <p style={{ ...customIndicator, background: "#ffe4a4" }}></p>
          <span>Cont</span>
        </div>
        <div className="row mt-3 overflow-auto">
          <div className="table-responsive" style={{ height: "400px", overflowY: "scroll" }}>
            <Table bordered>
               <TableHeader />

              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan={21} className="text-center py-4">
                      <div className="d-flex justify-content-center">
                        <FaSpinner class="spinner" />
                      </div>
                      <div className="text-muted mt-2">Loading</div>
                    </td>
                  </tr>
                ) : Object.keys(filteredData).length === 0 ? (
                  <tr>
                    <td colSpan={21} className="text-center text-muted py-3">
                      No Record Found
                    </td>
                  </tr>
                ) : (
                  Object.entries(
                    filteredData.reduce((acc, item) => {
                      if (!acc[item.ClientName]) acc[item.ClientName] = {};
                      if (!acc[item.ClientName][item.ProjectName])
                        acc[item.ClientName][item.ProjectName] = [];
                      acc[item.ClientName][item.ProjectName].push(item);
                      return acc;
                    }, {})
                  ).map(([clientName, projects], clientIndex) => {
                    const clientTotal = Object.values(projects)
                      .flat()
                      .reduce(
                        (sum, item) =>
                          sum + (Number(item.InvoiceCalculatedAmount) || 0),
                        0
                      );
                    console.log(
                      "Final clientTotal for",
                      clientName,
                      ":",
                      clientTotal
                    );
                    return (
                      <React.Fragment key={clientIndex}>
                        {/* Client Row - Keep original styling */}
                        <tr className="fw-bold text-dark">
                          <td
                            colSpan={colSpan1}
                            style={{
                              backgroundColor: "#27568c",
                              fontSize: "14px",
                              color: "#fff",
                              cursor: "pointer",
                            }}
                            onClick={() => handleClientToggle(clientIndex)}
                            className="p-0 m-0"
                          >
                            <div className="d-flex justify-content-between align-items-center p-2">
                              <span>{clientName}</span>
                            </div>
                          </td>

                          <td
                            style={{
                              backgroundColor: "#27568c",
                              fontSize: "14px",
                              color: "#fff",
                              textAlign: "right",
                              cursor: "pointer",
                              paddingRight: "20px",
                            }}
                            onClick={() => handleClientToggle(clientIndex)}
                          >
                            ₹{clientTotal.toLocaleString()}
                          </td>

                          <td
                            colSpan={colSpan2}
                            style={{
                              backgroundColor: "#27568c",
                              fontSize: "14px",
                              color: "#fff",
                              textAlign: "right",
                              cursor: "pointer",
                              paddingRight: "15px",
                            }}
                            onClick={() => handleClientToggle(clientIndex)}
                          >
                            <FontAwesomeIcon
                              icon={
                                activeClientKey === clientIndex ? faMinus : faPlus
                              }
                              style={{ cursor: "pointer" }}
                            />
                          </td>
                        </tr>

                        {/* Projects under Client */}
                        {activeClientKey?.includes(clientIndex) &&
                          Object.entries(projects).map(
                            ([projectName, items], projectIndex) => {
                              const projectTotal = items.reduce(
                                (sum, item) =>
                                  sum +
                                  (Number(item.InvoiceCalculatedAmount) || 0),
                                0
                              );

                              return (
                                <React.Fragment key={projectIndex}>
                                  {/* Project Row - Borderless */}
                                  <tr
                                    className="fw-bold text-secondary"
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                      handleProjectToggle(
                                        clientIndex,
                                        projectIndex
                                      )
                                    }
                                  >
                                    <td
                                      colSpan={colSpan1}
                                      style={{
                                        backgroundColor:
                                          items?.[0]?.FixedBid === 1
                                            ? "#bad893"
                                            : items?.[0]?.Consolidated === 1
                                              ? "#ffe4a4"
                                              : "#c3d6eb",
                                        fontSize: "14px",
                                      }}
                                      className="p-0 m-0"
                                    >
                                      <div className="d-flex justify-content-between align-items-center p-2 ps-3">
                                        <span>{projectName}</span>
                                      </div>
                                    </td>

                                    <td
                                      style={{
                                        backgroundColor:
                                          items?.[0]?.FixedBid === 1
                                            ? "#bad893"
                                            : items?.[0]?.Consolidated === 1
                                              ? "#ffe4a4"
                                              : "#c3d6eb",
                                        fontSize: "14px",
                                        textAlign: "right",
                                        paddingRight: "20px",
                                      }}
                                    >
                                      ₹{projectTotal.toLocaleString()}
                                    </td>

                                    <td
                                      colSpan={colSpan2}
                                      style={{
                                        backgroundColor:
                                          items?.[0]?.FixedBid === 1
                                            ? "#bad893"
                                            : items?.[0]?.Consolidated === 1
                                              ? "#ffe4a4"
                                              : "#c3d6eb",
                                        fontSize: "14px",
                                        textAlign: "right",
                                        paddingRight: "15px",
                                      }}
                                    >
                                      <FontAwesomeIcon
                                        icon={
                                          activeProjectKey[clientIndex] ===
                                            projectIndex
                                            ? faMinus
                                            : faPlus
                                        }
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleProjectToggle(
                                            clientIndex,
                                            projectIndex
                                          );
                                        }}
                                        style={{ cursor: "pointer" }}
                                      />
                                    </td>
                                  </tr>

                                  {/* Invoice Table for Project */}
                                  {(activeProjectKey[clientIndex] || []).includes(
                                    projectIndex
                                  ) && (
                                      <>
                                        {items.map((data, subIndex) => (
                                          <tr key={subIndex}>
                                            <td colSpan={3}></td>
                                            {columnVisibility.InvoiceDate !==
                                              false && (
                                                <td>
                                                  {data.InvoiceDate
                                                    ? moment(data.InvoiceDate).format(
                                                      "DD-MMM-YYYY"
                                                    )
                                                    : "-"}
                                                </td>
                                              )}
                                            {columnVisibility.InvoiceNo !==
                                              false && <td>{data.InvoiceNo}</td>}
                                            {columnVisibility.EmployeeName !==
                                              false && <td>{data.EmployeeName}</td>}
                                            {columnVisibility.PresentDays !==
                                              false && <td>{data.PresentDays}</td>}
                                            {columnVisibility.WorkingDays !==
                                              false && <td>{data.WorkingDays}</td>}
                                            {columnVisibility.StartDate !==
                                              false && <td>{data.StartDate}</td>}
                                            {columnVisibility.EndDate !==
                                              false && <td>{data.EndDate}</td>}
                                            {columnVisibility.BasicAmount !==
                                              false && (
                                                <td>{data.BasicAmount || 0.0}</td>
                                              )}
                                            {columnVisibility.AdjustmentAmount !==
                                              false && (
                                                <td>{data.AdjustmentAmount || 0.0}</td>
                                              )}
                                            {columnVisibility.InvoicedAmount !==
                                              false && (
                                                <td>{data.InvoicedAmount || 0.0}</td>
                                              )}
                                            {columnVisibility.TaxPercent !==
                                              false && (
                                                <td>{data.TaxPercent || 0}</td>
                                              )}
                                            {columnVisibility.ExchangeRate !==
                                              false && (
                                                <td>{data.ExchangeRate || 0}</td>
                                              )}
                                            {columnVisibility.InvoiceCalculatedAmount !==
                                              false && (
                                                <td>
                                                  ₹{data.InvoiceCalculatedAmount}
                                                </td>
                                              )}
                                            {columnVisibility.InvoicedDays !==
                                              false && (
                                                <td>{data.InvoicedDays}</td>
                                              )}
                                            {columnVisibility.PaymentTermDays !==
                                              false && (
                                                <td>{data.PaymentTermDays}</td>
                                              )}
                                            {columnVisibility.FollowUpDate !==
                                              false && (
                                                <td>
                                                  {data.FollowUpDate
                                                    ? moment(
                                                      data.FollowUpDate
                                                    ).format("DD-MMM-YYYY")
                                                    : ""}
                                                </td>
                                              )}
                                            {columnVisibility.PaymentDueDate !==
                                              false && (
                                                <td>
                                                  {data.PaymentDueDate
                                                    ? moment(
                                                      data.PaymentDueDate
                                                    ).format("DD-MMM-YYYY")
                                                    : ""}
                                                </td>
                                              )}
                                            {columnVisibility.PaymentReceivedDate !==
                                              false && (
                                                <td>
                                                  {data.PaymentReceivedDate
                                                    ? moment(
                                                      data.PaymentReceivedDate
                                                    ).format("DD-MMM-YYYY")
                                                    : ""}
                                                </td>
                                              )}
                                            {columnVisibility.OverDueDays !==
                                              false && (
                                                <td>{data.OverDueDays || 0.0}</td>
                                              )}
                                            {columnVisibility.OverDueAmount !==
                                              false && (
                                                <td>{data.OverDueAmount || 0.0}</td>
                                              )}
                                            {columnVisibility.Status !== false && (
                                              <td>
                                                {
                                                  statusOptions?.find(
                                                    (o) => o.value === data.Status
                                                  )?.label
                                                }
                                              </td>
                                            )}
                                            {columnVisibility.Remarks !==
                                              false && (
                                                <td>{data.Remarks || 0.0}</td>
                                              )}
                                          </tr>
                                        ))}
                                      </>
                                    )}
                                </React.Fragment>
                              );
                            }
                          )}
                      </React.Fragment>
                    );
                  })
                )}
              </tbody>
            </Table>
          </div>
        </div>

        <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center mb-3 gap-2">
          {/* Items per page selector and showing text */}
          <div className="d-flex align-items-center">
            <span className="me-2">
              Showing {(currentPage - 1) * itemsPerPage + 1} -{" "}
              {Math.min(currentPage * itemsPerPage, invoiceReportData.length)}{" "}
              of {invoiceReportData.length}
            </span>
            <select
              value={itemsPerPage}
              onChange={handleRecordsPerPage}
              className="mx-2 form-select-sm"
            >
              {recordsPerPageOption.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>

          {/* Pagination controls */}
          <div className="d-flex">
            <Pagination
              itemsPerPage={itemsPerPage}
              totalItems={invoiceReportData.length}
              currentPage={currentPage}
              onPageChange={handlePageChange}
            />
          </div>
        </div>
      </div>
    </div >
  );
};

export default InvoiceReportConsultingContent;